import { Pipe, PipeTransform } from '@angular/core';
import { LEGAL_BASIS_MAP } from './model/legal-basis';

@Pipe({ name: 'legalBasisToLabel' })
export class LegalBasisToLabelPipe implements PipeTransform {
  transform(legalBasis: string): string {
    return LEGAL_BASIS_MAP[legalBasis];
  }
}
